<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="checkinAssessGroup">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            评估组列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row style="float: left;">
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                </el-row>
                <div style="float:right">
                    <el-input  placeholder="请输入评估项名称" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                    <el-select
                        v-model="checkinAssessClassCode"
                            style="margin:0 10px;width:200px"
                        placeholder="请选择评估分类">
                        <el-option
                            v-for="item in classData"
                            :key="item.checkinAssessClassCode"
                            :label="item.name"
                            :value="item.checkinAssessClassCode">
                        </el-option>
                    </el-select>
                    <el-select
                        v-model="status"
                            style="margin:0 10px;width:200px"
                        placeholder="请选择入住状态">
                        <el-option
                            v-for="(item,i) in statusValue"
                            :key="i"
                            :label="item"
                            :value="i">
                        </el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>


            <div>


                <template>

                    <el-table :data="tableData"
                              :height="th"
                              highlight-current-row @row-click='rowClick'
                              border
                              style="width: 100%;" default-expand-all>
                        <el-table-column type="expand" v-if="tableData.length">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item :label="value.name" v-for="(value,i) in props.row.checkinAssessItemList" :key="i" >
                                        <span>{{value.fraction}}分</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>

                        <el-table-column prop="checkinAssessClass.name" label="入住评估分类"></el-table-column>

                        <el-table-column prop="name" label="名称"></el-table-column>

                        <el-table-column prop="maxFraction" label="最高分"></el-table-column>

                        <el-table-column
                                prop="status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>
                        <el-table-column prop="sort" label="排序"></el-table-column>


                        <!-- <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" v-if="scope.row.sort" size="small" @click="handleEdit(scope.$index, scope.row)">编辑
                                </el-button>
                            </template>
                        </el-table-column> -->


                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>


            </div>

        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-bind:classData="classData" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:classData="classData" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>


<script>
    import Add from "./Add";
    import Edit from "./Edit";
    import {timefilters, timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data() {
            return {
                loading: false,
                showModalAdd: false,
                showModalEdit: false,
                disabledAdd:true,
                disabledEdit:true,
                menuButtonList:null,
                row:null,
                tableData: [],
                classData: [],
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                th: 0,
                checkinAssessItemList: null,
                name: '',
                checkinAssessClassCode: '',
                statusValue:['全部状态','正常','禁用'],
                status:0,

            }
        },

        created() {
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                console.log(val);
                this.th = val;
            },
        },
        components: {
            Add, Edit
        },
        methods: {
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            rowClick(row){
                this.row=row
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit=false
                }
                
            },
            init() {
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "CheckinAssessClass/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response) => {
                    if (response.data.error == 0) {
                        this.classData = response.data.data;
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleEdit() {
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
            formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },


            getList() {
                var checkinAssessClassCode='00000000-0000-0000-0000-000000000000'
                if(this.checkinAssessClassCode){
                    checkinAssessClassCode=this.checkinAssessClassCode
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "CheckinAssessGroup/Page",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        name: this.name,
                        checkinAssessClassCode: checkinAssessClassCode,
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                        status:this.status-1
                    }
                }).then((response) => {
                    this.disabledEdit=true;
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row) {
                if (row.status == 0) {
                    return "正常";
                }
                if (row.status == 1) {
                    return "禁用";
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
   /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
    .checkinAssessGroup{
        .demo-table-expand /deep/ label {
            display: inline;
            color: #99a9bf;
        }

        .demo-table-expand /deep/ .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 100%;
        }
    }
</style>